import { useContext } from 'react';
import { useAPI } from '../lib/hooks';
import { AppContext } from '../sporttia/AppContext';
import useRestService from './RestService';
import constants from '../config/constants';

const resource = '/me';

/**
 * Hook to access all 'me' resources.
 */
export default function useMeService() {
    const { migrationApis } = useContext(AppContext)!;
    const [request] = useAPI(migrationApis);
    const services = useRestService(resource);

    /**
     * PUT /me request.
     * @param params Resource parameters to be sent with the request.
     * @returns {Promise<unknown>|*} Return request promise.
     */
    function updateMe(params?: Record<string, unknown>): Promise<unknown> {
        return request('PUT', resource, params);
    }

    /**
     * GET /me/in-app-notifications request.
     * @returns {Promise<unknown>|*} Return request promise.
     */
    function getMeNotifications(): Promise<unknown> {
        return request(
            'GET',
            `${constants.boundedContextPrefixes.COMMUNICATIONS}${resource}/in-app-notifications`,
        );
    }

    return {
        ...services,
        updateMe,
        getMeNotifications,
    };
}
